import { Controller } from '@hotwired/stimulus'

export default class ConversationListController extends Controller {
  static targets = ['pinnedTitle', 'pinnedList', 'allTitle', 'allList']

  connect() {
    this.toggleTitles()

    this.observer = new MutationObserver(() => {
      this.toggleTitles()
    })

    this.observer.observe(this.pinnedListTarget, { childList: true })
    this.observer.observe(this.allListTarget, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggleTitles() {
    const pinnedCount = this.pinnedListTarget.children.length
    const allCount = this.allListTarget.children.length

    // Show 'Bookmark conversation' only if pinned users exist
    this.pinnedTitleTarget.classList.toggle('d-none', pinnedCount === 0)

    // Show 'All conversation' only if both sections have items
    this.allTitleTarget.classList.toggle('d-none', !(pinnedCount > 0 && allCount > 0))
    this.sortAllConversations()
  }

  sortAllConversations() {
    const rooms = Array.from(this.allListTarget.children)

    const sortedRoom = [...rooms].sort((a, b) => {
      const firstItem = Number(a.querySelector("em[data-time]")?.dataset.time || 0)
      const secondItem = Number(b.querySelector("em[data-time]")?.dataset.time || 0)

      return secondItem - firstItem
    })

    const hasChanged = rooms.some((room, index) => room !== sortedRoom[index])
    if (!hasChanged) return

    this.observer.disconnect()

    sortedRoom.forEach(room => this.allListTarget.appendChild(room))

    this.observer.observe(this.pinnedListTarget, { childList: true })
    this.observer.observe(this.allListTarget, { childList: true })
  }
}